module.exports = "<ng-multiselect-dropdown\r\n  [settings]=\"dropdownSettings\"\r\n  [data]=\"dropdownList\"\r\n  [(ngModel)]=\"selectedItems\"\r\n  (ngModelChange)=\"emitByType()\"\r\n  [ngClass]=\"{'hidden': !isLoad }\">\r\n</ng-multiselect-dropdown>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/multi-select-dropdown/payor-multi-select/payor-multi-select.component.html
// module id = 2344
// module chunks = 66